"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  border-radius: 500rem;\n  background-color: ", ";\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 1em;\n  margin-top: ", ";\n  background-color: ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  margin-right: 8px;\n  background-color: ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 1.5s infinite;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: .6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: .6;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Placeholder =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Placeholder, _React$Component);

  function Placeholder(props) {
    var _this;

    _classCallCheck(this, Placeholder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Placeholder).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "placeholders", {
      rect: Placeholder.Rect,
      text: Placeholder.Text,
      round: Placeholder.Round
    });

    _defineProperty(_assertThisInitialized(_this), "_delayIfNeeded", function () {
      var _this$props = _this.props,
          ready = _this$props.ready,
          delay = _this$props.delay;
      if (ready) return ready;

      if (delay && delay > 0) {
        _this.initTimeout = setTimeout(function () {
          return _this.setState({
            ready: false
          });
        }, delay);
        return true;
      }

      return ready;
    });

    _defineProperty(_assertThisInitialized(_this), "setReady", function () {
      clearTimeout(_this.initTimeout);
      clearTimeout(_this.timeout);
      if (!_this.state.ready) _this.setState({
        ready: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setNotReady", function () {
      var delay = _this.props.delay;

      if (delay && delay > 0) {
        _this.timeout = setTimeout(function () {
          return _this.setState({
            ready: false
          });
        }, delay);
      } else {
        _this.setState({
          ready: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getPlaceholder", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          ready = _this$props2.ready,
          children = _this$props2.children,
          delay = _this$props2.delay,
          firstLaunchOnly = _this$props2.firstLaunchOnly,
          customPlaceholder = _this$props2.customPlaceholder,
          rest = _objectWithoutProperties(_this$props2, ["type", "ready", "children", "delay", "firstLaunchOnly", "customPlaceholder"]);

      if (customPlaceholder && _react["default"].isValidElement(customPlaceholder)) {
        return _react["default"].cloneElement(customPlaceholder, _objectSpread({}, customPlaceholder.props, rest));
      } else if (customPlaceholder) {
        return customPlaceholder;
      }

      var PH = _this.placeholders[type];
      return _react["default"].createElement(PH, rest);
    });

    _this.state = {
      ready: _this._delayIfNeeded()
    };
    return _this;
  }

  _createClass(Placeholder, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
        this.setNotReady();
      } else if (nextProps.ready) {
        this.setReady();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.initTimeout);
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.ready ? this.props.children : this.getPlaceholder();
    }
  }]);

  return Placeholder;
}(_react["default"].Component);

Placeholder.Element = _styledComponents["default"].div(_templateObject());
var pulse = (0, _styledComponents.keyframes)(_templateObject2());
var animation = (0, _styledComponents.css)(_templateObject3(), pulse);
Placeholder.Rect = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.color ? props.color : '#CDCDCD';
}, animation);
Placeholder.Text = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.lineSpacing ? props.lineSpacing : '0.7em';
}, function (props) {
  return props.color ? props.color : '#CDCDCD';
}, animation);
Placeholder.Round = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.color ? props.color : '#CDCDCD';
}, animation);
Placeholder.propTypes = {
  color: _propTypes["default"].string,
  syle: _propTypes["default"].object,
  type: _propTypes["default"].oneOf(['rect', 'text', 'round']),
  ready: _propTypes["default"].bool.isRequired,
  delay: _propTypes["default"].number,
  firstLaunchOnly: _propTypes["default"].bool,
  customPlaceholder: _propTypes["default"].node
};
Placeholder.defaultProps = {
  color: '#CDCDCD',
  type: 'text',
  delay: 0,
  firstLaunchOnly: false
};
var _default = Placeholder;
exports["default"] = _default;